import React from "react";

import { ListItemIcon, MenuItem, Typography } from "@mui/material";
import Logout from "@mui/icons-material/Logout";

import { useAuth } from "../../context/AuthContext";
import { CustomListIcon } from "../NavBar/ExpandedNavItems";
import { usePanelContext } from "../../context/PanelContext";
import { useEventTracking } from "../../context/EventTrackingContext";

export const SignOutItem = () => {
  const { setExpandedPanel } = usePanelContext();
  const { logOut } = useAuth();
  const { endSession } = useEventTracking();

  const handleLogout = () => {
    setExpandedPanel(null);
    void endSession();
    logOut();
  };

  return (
    <MenuItem onClick={() => handleLogout()}>
      <CustomListIcon>
        <Logout fontSize="small" />
      </CustomListIcon>
      <Typography variant="body2">Logout</Typography>
    </MenuItem>
  );
};
